/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Empty, Input, Select, Switch, Table, Tabs } from "antd";
import { EditOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import AtualizacaoRequest from "../Movimentacao/Atualizacao/atualizacao";
import { colors } from "../../Utils/temas";
import { useUserContext } from "../../contexts/usersContext";
import { EditarRegistro } from "./EditarRegistro";

export const ConsultaEmTeste = () => {
  const { currentUser } = useUserContext();

  const [usuarios, setUsuarios] = useState([
    { id: 0, nome: "", is_superuser: false, is_staff: false },
  ]);
  const [usuariosEmTeste, setUsuariosEmTeste] = useState({});
  const [edicao, setEdicao] = useState(null);

  const [usuarioIdSelecionado, setUsuarioIdSelecionado] = useState(
    currentUser.id,
  );

  const [loading, setLoading] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [filtrar, setFiltrar] = useState(true);
  const [ticket, setTicket] = useState("");

  useEffect(() => {
    listarEmTeste();
    listarUsuarios();
  }, []);

  const listarUsuarios = async () => {
    setLoadingUsers(true);
    try {
      const response = await AtualizacaoRequest.getListarUsuarios();
      if (response.status === 200 || response.status === 201) {
        const { results } = response.data;
        setUsuarios(results);
        setLoadingUsers(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const listarEmTeste = async () => {
    setLoading(true);
    try {
      const response =
        await AtualizacaoRequest.getEmTeste(usuarioIdSelecionado, ticket);
      if (response.status === 200 || response.status === 201) {
        setUsuariosEmTeste(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const colunaAcoes = (tipo) => ({
    title: "Ações",
    key: "acoes",
    render: (_, registro) => (
      <Button
        type="text"
        icon={<EditOutlined />}
        disabled={registro.id == null || loading}
        onClick={() => setEdicao({ tipo, registro })}
      >
        Alterar
      </Button>
    ),
  });

  const dictionaryFieldsTest = {
    dominio_em_teste: "Dominio",
    tabela_em_teste: "Tabela",
    campo_em_teste: "Campo",
    foreignKey_em_teste: "Foreign Key",
    primaryKey_em_teste: "Primary Key",
    index_em_teste: "Index",
    trigger_em_teste: "Trigger",
    procedure_em_teste: "Procedure",
    view_em_teste: "View",
    sequences_em_teste: "Sequences",
    comando_em_teste: "Comando",
    parametro_em_teste: "Parâmetro",
    permissao_em_teste: "Permissão",
  };

  const columns = {
    dominio_em_teste: [
      { title: "Nome", dataIndex: "nome" },
      { title: "Tipo Coluna Firebird", dataIndex: "tipo_coluna_firebird" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    tabela_em_teste: [
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    campo_em_teste: [
      { title: "Tabela", dataIndex: "tabela__nome" },
      { title: "Nome", dataIndex: "nome" },
      { title: "Dominio", dataIndex: "dominio__nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    foreignKey_em_teste: [
      { title: "Tabela", dataIndex: "campo__tabela__nome" },
      { title: "Campo", dataIndex: "campo__nome" },
      { title: "Domínio", dataIndex: "campo__dominio__nome" },
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    primaryKey_em_teste: [
      { title: "Tabela", dataIndex: "campo__tabela__nome" },
      { title: "Campo", dataIndex: "campo__nome" },
      { title: "Domínio", dataIndex: "campo__dominio__nome" },
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    index_em_teste: [
      { title: "Tabela", dataIndex: "campo__tabela__nome" },
      { title: "Campo", dataIndex: "campo__nome" },
      { title: "Domínio", dataIndex: "campo__dominio__nome" },
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    trigger_em_teste: [
      { title: "Tabela", dataIndex: "tabela__nome" },
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    procedure_em_teste: [
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    view_em_teste: [
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    sequences_em_teste: [
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    comando_em_teste: [
      {
        title: "Descrição",
        dataIndex: "descricao",
      },
      {
        title: "Data Atualização",
        dataIndex: "data_atualizacao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    parametro_em_teste: [
      {
        title: "Sistema",
        dataIndex: "config_grupo__sistema__nome_sistema",
      },
      { title: "Descrição", dataIndex: "config_grupo__descricao" },
      { title: "Seção", dataIndex: "secao" },
      { title: "Nome", dataIndex: "nome" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
    permissao_em_teste: [
      {
        title: "Sistema",
        dataIndex: "menu__sistema__nome_sistema",
      },
      { title: "Descrição", dataIndex: "menu__descricao" },
      { title: "Chave Rotina", dataIndex: "chave_rotina" },
      {
        title: "Data Alteração",
        dataIndex: "data_alteracao",
        render: (value) => {
          if (value) {
            const date = new Date(value);
            const dateFormatted = date.toLocaleString().replace(",", "");
            return dateFormatted;
          }
        },
      },
    ],
  };

  const colunaticket = {
    title: "Ticket",
    dataIndex: "ticket",
    key: "ticket"
  };

  const onlySuperUser = usuarios.filter(
    (item) => item.is_superuser || item.is_staff,
  );

  const visibleTabs = Object.keys(dictionaryFieldsTest).filter((key) => {
    if (!filtrar) return true;

    return (
      Array.isArray(usuariosEmTeste[key]) && usuariosEmTeste[key].length > 0
    );
  });

  return (
    <>
      {edicao && (
        <EditarRegistro
          key={`${edicao.tipo}:${edicao.registro.id}`}
          tipo={edicao.tipo}
          registro={edicao.registro}
          onCancel={() => setEdicao(null)}
          onSave={listarEmTeste}
        />
      )}
      <div style={{ padding: 8 }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 16, alignItems: "flex-end" }}>
          <div style={{ width: "15.2%" }}>
            <text style={{ fontWeight: "500" }}>Nome usuário:</text>
            <Select
              showSearch
              options={onlySuperUser?.map((item) => ({
                label: item.nome,
                value: item.id,
              }))}
              filterOption={(input, option) =>
                (option.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              allowClear
              style={{ width: "100%" }}
              onChange={(value) => setUsuarioIdSelecionado(value)}
              value={loadingUsers ? "" : usuarioIdSelecionado}
              loading={loadingUsers}
            />
          </div>
          <div style={{ width: 200 }}>
            <label htmlFor="consulta-em-teste-ticket" style={{ fontWeight: "500" }}>
              Ticket:
            </label>
            <Input
              id="consulta-em-teste-ticket"
              placeholder="Informe o ticket"
              allowClear
              value={ticket}
              onChange={(event) => setTicket(event.target.value)}
              onPressEnter={listarEmTeste}
            />
          </div>
          <Button
            style={{
              background: colors.secondary,
              color: "white",
              fontWeight: "500",
            }}
            loading={loading}
            onClick={listarEmTeste}
          >
            Pesquisar
          </Button>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <text style={{ fontWeight: "500" }}>Filtrar apenas com dados</text>
            <div>
              <Switch
                checked={filtrar}
                onChange={(checked) => setFiltrar(checked)}
              />
            </div>
          </div>
        </div>
      </div>

      <Tabs type="card" size="large" style={{ marginTop: 16 }}>
        {visibleTabs.length > 0 &&
          visibleTabs.map((key) => (
            <Tabs.TabPane key={key} tab={dictionaryFieldsTest[key]}>
              <Table
                loading={loading}
                columns={[...columns[key], colunaticket, colunaAcoes(key)]}
                rowKey="id"
                dataSource={usuariosEmTeste[key]}
                style={{ marginTop: -18 }}
              />
            </Tabs.TabPane>
          ))}
      </Tabs>

      {visibleTabs.length === 0 && (
        <div style={{ width: "100%" }}>
          <Empty
            description={
              <span style={{ fontWeight: "500" }}>
                Nenhum dado encontrado para o filtro selecionado!
              </span>
            }
          />
        </div>
      )}
    </>
  );
};
